import DatePickerWrapper from '../../components/DatePicker/DatePickerWrapper';
import { FormControl, Select, MenuItem, CircularProgress, Typography } from '@mui/material';
import {useEffect, useState} from "react";
import CandidatTasksTable from "./Tables/CandidatTasksTable";
import ContactTasksTable from "./Tables/ContactTasksTable"
import { getAllUsersForTasks } from "../../services/UserService";
import { getUserData } from "../../utils/FunctionHelpers";
import { Box } from '@mui/material';
import "./candidatTaskStyle.css"
import { withSnackbar } from "../../utils/SnackbarHOC";
import { v4 } from "uuid";

function CandidatTasks({ snackbarShowMessage }) {
  const [loadUsers, setLoadUser] = useState(false);
  const [affectePar, setAffectePar] = useState();
  const [affecteA, setAffecteA] = useState(getUserData().uuid);
  const [dateFilter, setDateFilter] = useState("aujourduietpasse");
  const [dueDate, setDueDate] = useState();
  const [users, setUsers] = useState([]);
  const [reloadingData, setReloadingData] = useState(false);
  const searchParams = { affecteA, affectePar, dueDate, dateFilter };
  const tachesCandidatProps = { searchParams, reloadingData, setReloadingData };
  const tachesContactProps = { searchParams, reloadingData, setReloadingData };


  const dateFilterData = {
    toutes: "TOUTES",
    aujourduietpasse: "AUJOURD'HUI ET PASSÉES",
    aujourduietavenir: "AUJOURD'HUI ET À VENIR",
    pardate: "PAR DATE",
    faites: "FAITES"
  };

  const handleParDate = (e) => {
    if (e.target.value === "pardate") {
      setDateFilter(e.target.value);
      setDueDate(new Date());
      return;
    }
    setDueDate();
    setDateFilter(e.target.value);
    setReloadingData(!reloadingData);
  };

  useEffect(() => {
    let active = true;
    (async () => {
      setLoadUser(true);
      try {
        const users = await getAllUsersForTasks();
        if (!active) {
          return;
        }
        setUsers(users.data);
        setLoadUser(false);
      } catch (error) {
        if (!active) {
          return;
        }
        snackbarShowMessage("Erreur de chargement des utilisateurs.", "error", 4000);
      } finally {
        setLoadUser(false);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  const taches_list =
    [{ value: 0, name: "candidats" },
    { value: 1, name: "contacts" }]

  const [toggleList, setToggletList] = useState(0)


  return (
    <Box sx={{ px: '20px', pb: 2, backgroundColor: '#f1f5f9', minHeight: '100vh' }}>

      <Typography sx={{ pt: 2, pb: 1.5, color: '#0f172a', fontFamily: "'Fira Sans', sans-serif", fontWeight: 700, fontSize: '1.5rem', letterSpacing: '-0.01em' }}>
        MA LISTE DE TÂCHES
      </Typography>

      {/* ── Filters card ── */}
      <Box sx={{
        background: '#ffffff',
        borderRadius: '14px',
        border: '1px solid #e2e8f0',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.04)',
        p: '16px 24px',
        mb: 2.5,
        display: 'flex',
        alignItems: 'flex-end',
        gap: 3,
      }}>
        {/* Tâches des */}
        <Box sx={{ flex: 1, minWidth: 120 }}>
          <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}>
            Tâches des
          </Typography>
          <FormControl variant="outlined" fullWidth size="small">
            <Select name="affectePar" onChange={(e) => setToggletList(e.target.value)} defaultValue={0}>
              {taches_list.map((list) => (
                <MenuItem value={list.value} key={list.value}>{list.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* Affectées par */}
        <Box sx={{ flex: 1, minWidth: 150 }}>
          <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}>
            Affectées par
          </Typography>
          <FormControl variant="outlined" fullWidth size="small">
            <Select name="affectePar" onChange={(e) => { setAffectePar(e.target.value); setReloadingData(!reloadingData); }} defaultValue="">
              {loadUsers ? (
                <Box display="flex" justifyContent="center" p={1}><CircularProgress size={20} /></Box>
              ) : (
                users.map((user) => (
                  <MenuItem value={user.uuid} key={user.uuid}>{user.prenom} {user.nom}</MenuItem>
                ))
              )}
            </Select>
          </FormControl>
        </Box>

        {/* Affectées à */}
        <Box sx={{ flex: 1, minWidth: 150 }}>
          <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}>
            Affectées à
          </Typography>
          <FormControl variant="outlined" fullWidth size="small">
            {loadUsers ? (
              <Box display="flex" justifyContent="center" p={1}><CircularProgress size={20} /></Box>
            ) : (
              <Select value={users.length > 0 ? affecteA : ""} name="users" onChange={(e) => { setReloadingData(!reloadingData); setAffecteA(e.target.value); }}>
                {users.map((user) => (
                  <MenuItem value={user.uuid} key={user.uuid}>{user.prenom} {user.nom}</MenuItem>
                ))}
              </Select>
            )}
          </FormControl>
        </Box>

        {/* Afficher les tâches */}
        <Box sx={{ flex: 1.4, minWidth: 180 }}>
          <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}>
            Afficher les tâches
          </Typography>
          <FormControl variant="outlined" fullWidth size="small">
            <Select name="dateFilter" onChange={(e) => { setReloadingData(!reloadingData); handleParDate(e); }} value={dateFilter}>
              {Object.keys(dateFilterData).map((keyname) => (
                <MenuItem value={keyname} key={v4()}>{dateFilterData[keyname]}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* Par date (conditional) */}
        {dateFilter === "pardate" && (
          <Box sx={{ flex: 1, minWidth: 140 }}>
            <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}>
              Par date
            </Typography>
            <DatePickerWrapper
              disableToolbar variant="inline" views={["date", "month", "year"]}
              format="dd/MM/yyyy" inputVariant="outlined" margin="normal" fullWidth
              onChange={(date) => { setDueDate(date); setReloadingData(!reloadingData); }}
            />
          </Box>
        )}
      </Box>

      {/* ── Table ── */}
      {toggleList === 0 ? <CandidatTasksTable {...tachesCandidatProps} /> : <ContactTasksTable {...tachesContactProps} />}
    </Box>
  );
}

export default withSnackbar(CandidatTasks);
